import { ExtendedSelectionGroup } from '@oneaudi/unified-web-alpha-components';
import styled, { keyframes } from 'styled-components';
export const slideDown = keyframes`
	from {
		height: 0;
	}
	to {
		height: var(--radix-collapsible-content-height);
	}
`;

export const slideUp = keyframes`
	from {
		height: var(--radix-collapsible-content-height);
		opacity: 1;
	}
	to {
		height: 0;
		opacity: 0;
	}
`;
export const StyledExtendedSelectionGroup = styled(ExtendedSelectionGroup)`
	.selection-card-description {
		display: flex;
		flex-direction: column;
		gap: 8px;
		align-items: start;
		margin-bottom: 2px;

		.disclaimer-wrapper {
			margin-top: 8px;
			width: 100%;
		}
	}
	.collapsible-content {
		overflow: hidden;
		.content-container {
			display: grid;
			gap: 1rem;
			padding: 0 0 16px 0;
		}
		.disclaimer-wrapper {
			margin-top: 16px;
		}
	}
	.collapsible-content[data-state='open'] {
		animation: ${slideDown} 400ms ease;
	}
	.collapsible-content[data-state='closed'] {
		animation: ${slideUp} 400ms ease;
	}
`;
